export const socialData = [
  {
    image: require("assets/icons/social/facebook.svg").default,
    alt: "Facebook",
    url: "https://www.facebook.com/spokojwglowie",
  },
  {
    image: require("assets/icons/social/instagram.svg").default,
    alt: "Instagram",
    url: "https://www.instagram.com/spokojwglowie.pl/",
  },
  {
    image: require("assets/icons/social/znany-lekarz.svg").default,
    alt: "ZnanyLekarz",
    url: "https://www.znanylekarz.pl/monika-chrapinska-krupa/psycholog-psycholog-dzieciecy-psychoterapeuta/wolomin",
  },
  {
    image: require("assets/icons/social/saloner.svg").default,
    alt: "Saloner",
    url: "https://saloner.pl/salon/10871-spokoj-w-glowie",
  },
];
